import { getAuthUserId } from '@library/auth'
import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'
import { Menu } from './types'
import {
  SUPPORTED_OPTION_TYPES_INGREDIENTS,
  SUPPORTED_OPTION_TYPES_RECIPES,
} from '../../internal/types'

export type MenuRequestParams = {
  date?: string
  deliveryDate?: string
  numPortions: number
  includeRecipeGroups?: boolean
  includeIngredientCustomisations?: boolean
  motivationIds?: string[]
  // admin link data
  'preview[menu_id]'?: string
  'preview[auth_user_id]'?: string
  'preview[expiry]'?: string
  'preview[signature]'?: string
}

const menuApiMenuParse = async (response: Response): Promise<Menu> => {
  const body = await response.text()
  const parsedBody = JSON.parse(body)

  if (!response.ok) {
    throw new Error(parsedBody.message)
  }

  return parsedBody as Menu
}

const menuApiMenuRequest = composeRequest(
  setServiceUrl('menu', 3),
  addPath((params: MenuRequestParams | undefined) => {
    // if it is admin query
    if (params && params['preview[auth_user_id]']) {
      return `menus/${params['preview[menu_id]']}/preview`
    }

    return 'menus'
  }),
  goustoHeaders,
  setQueryParams(
    ({
      date,
      deliveryDate,
      numPortions,
      motivationIds,
      includeRecipeGroups,
      includeIngredientCustomisations,
      ...rest
    }: MenuRequestParams) => {
      const isAdminQuery = rest && rest['preview[auth_user_id]']

      const userId = isAdminQuery ? rest['preview[auth_user_id]'] : getAuthUserId()

      return {
        include_core_recipe_id: 'true',
        include_core_menu_id: 'true',
        ...(date && { date }),
        ...(deliveryDate && { delivery_date: deliveryDate }),
        num_portions: numPortions.toString(),
        option_types: includeIngredientCustomisations
          ? [...SUPPORTED_OPTION_TYPES_INGREDIENTS]
          : [...SUPPORTED_OPTION_TYPES_RECIPES],
        ...(motivationIds && { motivation_ids: motivationIds }),
        ...(userId && { user_id: userId }),
        ...(isAdminQuery && {
          signature: rest['preview[signature]'],
          expiry: rest['preview[expiry]'],
        }),
        ...(includeRecipeGroups && {
          include_recipe_groups: includeRecipeGroups.toString(),
        }),
      }
    },
  ),
  setMethod('GET'),
)

export const menuFetcher = composeFetch(menuApiMenuRequest, menuApiMenuParse)
